import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import Home from './views/Home.vue'
// import Main from './views/Main.vue'
import Page1 from './views/nav1/Page1.vue'
import Page2 from './views/nav2/Page2.vue'
import Page3 from './views/nav3/Page3.vue'
import Page4 from './views/nav4/Page4.vue'
import echarts from './views/charts/echarts.vue'
import exportExcel from './views/excel/export.vue'
import uploadExcel from './views/excel/uploadExcel.vue'
import tinymceEditor from './components/Tinymce/index.vue'

import desktop from './views/desktop/desktop.vue'
import admin from './views/admin/admin.vue'

import orderMgr from './views/order/order_mgr.vue'
import textMgr from './views/hand/text_mgr.vue'
import timeMgr from './views/hand/time_mgr.vue'
import dateMgr from './views/hand/date_mgr.vue'
import dictMgr from './views/hand/dict_mgr.vue'

let routes = [
    {
        path: '/',
        component: Login,
        name: '',
        hidden: true
    },
    {
        path: '/login',
        component: Login,
        name: '',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
    {
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    },
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa el-icon-data-line',//图标样式class
        leaf: true,//只有一个节点
        children: [
            { path: '/desktop', component: desktop, name: '系统首页' },
        ]
    },
    {
        path: '/',
        component: Home,
        name: '订单管理',
        iconCls: 'fa fa-cog',//图标样式class
        leaf: true,//只有一个节点
        children: [
            { path: '/order_mgr', component: orderMgr, name: '订单管理' },
        ]
    },
    {
        path: '/',
        component: Home,
        name: '上屏设置',
        iconCls: 'fa fa-cog',//图标样式class
        leaf: false,//只有一个节点
        children: [
            { path: '/text_mgr', component: textMgr, name: '文字管理', leaf: true, isAdmin: true },
            { path: '/date_mgr', component: dateMgr, name: '日期管理', leaf: true, isAdmin: true },
            { path: '/time_mgr', component: timeMgr, name: '时间管理', leaf: true, isAdmin: true },
        ]
    },
    {
        path: '/',
        component: Home,
        name: '配置管理',
        iconCls: 'fa fa-cog',//图标样式class
        leaf: true,//只有一个节点
        children: [
            { path: '/dict_mgr', component: dictMgr, name: '配置管理' },
        ]
    },
    // {
    //     path: '/',
    //     component: Home,
    //     name: '文字管理',
    //     iconCls: 'fa fa-cog',//图标样式class
    //     leaf: true,//只有一个节点
    //     children: [
    //         { path: '/text_mgr', component: textMgr, name: '文字管理' },
    //     ]
    // },
    // {
    //     path: '/',
    //     component: Home,
    //     name: '时间管理',
    //     iconCls: 'fa fa-cog',//图标样式class
    //     leaf: true,//只有一个节点
    //     children: [
    //         { path: '/time_mgr', component: timeMgr, name: '文字管理' },
    //     ]
    // },
    // {
    //     path: '/',
    //     component: Home,
    //     name: '测试项目管理/子任务管理',
    //     iconCls: 'fa fa-cog',//图标样式class
    //     leaf: true,//只有一个节点
    //     children: [
    //         { path: '/task_mgr/task_sub_mgr', component: taskSubMgr, name: '测试项目管理' },
    //     ],
    //     hidden: true
    // },
    // {
    //     path: '/',
    //     component: Home,
    //     name: '模型设置',
    //     iconCls: 'fa fa-cog',//图标样式class
    //     leaf: false,//只有一个节点
    //     children: [
    //         // { path: '/image_pre_handle', component: imagePreHandle, name: '图像预处理', leaf: true },
    //         // { path: '/model_train', component: modelTrain, name: '网络训练', leaf: true, isAdmin: true },
    //         { path: '/model_mgr', component: modelMgr, name: '权重管理', leaf: true, isAdmin: true },
    //     ]
    // },
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa el-icon-user',//图标样式class
        leaf: true,//只有一个节点
        children: [
            { path: '/admin', component: admin, name: '账户管理' },
        ]
    },
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js